import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { BankDetails } from 'types/bankDetails'

export const bankAccountsApi = createApi({
  reducerPath: 'bankAccounts',
  baseQuery,
  tagTypes: ['BankAccounts'],
  endpoints: (builder) => ({
    bankAccounts: builder.query<BankDetails[], void>({
      query: () => ({
        url: '/bank-accounts',
      }),
      providesTags: ['BankAccounts'],
    }),

    bankAccount: builder.query<BankDetails, IdParams>({
      query: ({ id }) => `/bank-accounts/${id}`,
    }),

    createBankAccount: builder.mutation<BankDetails, Partial<BankDetails>>({
      query: (body) => ({
        url: '/bank-accounts',
        body,
        method: 'post',
      }),
      invalidatesTags: ['BankAccounts'],
    }),

    deleteBankAccount: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/bank-accounts/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['BankAccounts'],
    }),
  }),
})

export const {
  useBankAccountQuery,
  useBankAccountsQuery,
  useCreateBankAccountMutation,
  useDeleteBankAccountMutation,
} = bankAccountsApi
